import { Avatar } from "@mui/material";
import Link from "next/link";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as constants from "../../Components/constants";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { NextSeo } from "next-seo";
import InArticleAds from "../../Components/GoogleAdsense/InArticleAds";
import CustomLoader from "../../Components/CustomLoader/CustomLoader";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SearchIcon from "@mui/icons-material/Search";
import style from "../../styles/discover.module.css";
import CourseAd from "../../Components/Group/GroupDiscover/CourseAd/CourseAd";
import AllGroups from "../../Components/Group/AllGroups/AllGroups";

const BASE_URL = constants.BASE_URL;

const Discover = ({ isLoggedIn, adsId }) => {
  const [otherGroup, setOtherGroup] = React.useState([]);
  const [isLoading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState("");
  let slot = 9242238657;
  let cardAd = 5662403529;

  React.useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/group/all-groups/`)
      .then((res) => res.json())
      .then((data) => {
        setOtherGroup(data);
        setLoading(false);
      });
  }, []);

  //Group searching Function

  const otherGroupSearch = (e) => {
    const keyword = e.target.value;
    if (keyword !== "") {
      const results = otherGroup.filter((group) => {
        return group.name.toLowerCase().startsWith(keyword.toLowerCase());
      });
      setOtherGroup(results);
    } else {
      fetch(`${BASE_URL}/group/all-groups/`)
        .then((res) => res.json())
        .then((data) => {
          setOtherGroup(data);
        });
    }
    setSearch(keyword);
  };
  const content = {
    height: "40px",
  };

  if (!otherGroup) return <p>No profile data</p>;
  return (
    <>
      <NextSeo
        title="Research Rider | Group Discover"
        description="Be connected with the worldwide research hub."
        canonical="https://www.researchrider.com/group/discover"
        openGraph={{
          url: "https://www.researchrider.com/group/discover",
          title: "Research Rider | Group Discover",
          description: "Be connected with the worldwide research hub.",
          siteName: "Research Rider",
        }}
      />

      <div
        className={
          isLoggedIn
            ? `${style.banner} p-2 mt-5`
            : `${style.banner_box} ${style.banner}`
        }
      >
        <CourseAd />
      </div>
      <Container>
        <AllGroups />
      </Container>
    </>
  );
};

export default Discover;
